import { KeyValue } from "./key-value";

export class WorkflowTask {
  version?: string;
  name: string;
  id: string;
  enabled: boolean;
  inputs: KeyValue[];
  status = 'unchanged';
  childStatus = 'unchanged';

  public constructor(name: string, id: string, enabled: boolean, inputs: KeyValue[]) {
    this.name = name;
    this.inputs = inputs;
    this.id = id;
    this.enabled = enabled;
  }
}